import React from 'react';
import 'promise-polyfill/src/polyfill';
import './polyfills';
import { Provider } from 'react-redux';
import { A2HSProvider } from 'react-a2hs';
import { LocalizeProvider } from 'react-localize-redux';
import { renderToStaticMarkup } from 'react-dom/server';
import store from './store';
import GlobalTranslations from './global.translations.json';
import Page from './page';

const App = () => (
  <Provider store={store}>
    <A2HSProvider
      buttonText="Legg til på hjem-skjerm"
    >
      <LocalizeProvider
        store={store}
        initialize={{
          languages: [
            { name: 'Norsk bokmål', code: 'nb' },
            { name: 'English', code: 'en' },
          ],
          translation: GlobalTranslations,
          options: {
            defaultLanguage: 'nb',
            renderToStaticMarkup,
          },
        }}
      >
        <Page />
      </LocalizeProvider>
    </A2HSProvider>
  </Provider>
);

export default App;
